var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { class: [_vm.className] },
    [
      _c("transition", { attrs: { name: "view" } }, [_c("RouterView")], 1),
      _vm._v(" "),
      _vm.showOverlay ? _c("overlay") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }